export default __webpack_public_path__ + "static/media/miljöpartiet_logga.b52cf3ff.png";